import React, { useMemo } from "react";
// import { ContactCrawlHeaderFragmentParameter } from "@/app/pages/contactIndustrySearch/interface";
import { filterOutUndefineds } from "@/shared/Internal";

import Breadcrumb from "@/components/breadCrumb";
// import {ContactCrawlBreadcrumbFragmentComponent} from "@/ContactCrawlBreadcrumbFragment/ContactCrawlBreadcrumbFragment";
import "@/app/pages/contactIndustrySearch/styles/ContactCrawlHeaderStyles.scss";
import { isNotUndefinedOrNull, isUndefinedOrNull } from "@/shared/FunctionCore";
import { Helmet } from "react-helmet";

const ContactCrawlHeader = (props: any): JSX.Element => {
	const {
		contactIndustryBreadcrumbData,
		contactIndustryHeaderDataInner,
		totalContacts
	} = props;

	const breadcrumbs = useMemo(() => {
		let crumbs = [
			{ name: "Home", url: "/" },
			{ name: "Contact Directory", url: "/contact-directory.html" }
		]

		let result = []

		if (contactIndustryBreadcrumbData) {

			let copiedBreadcrumbs = [...contactIndustryBreadcrumbData];

			result = copiedBreadcrumbs.map((bc, i) => {
				if (contactIndustryBreadcrumbData.length > 1) {
					if (isNotUndefinedOrNull(contactIndustryHeaderDataInner?.addressLocality)) {
						if (i === copiedBreadcrumbs.length - 2) {
							bc["url"] = copiedBreadcrumbs[0]["url"].replace(".html", `.us.${bc.url}.html`)
						} else {
							bc["url"] = `/contact-directory/contact-industry-search.${bc.url}.html`
						}
					} else bc["url"] = `/contact-directory/contact-industry-search.${bc.url}.html`
				} else {
					bc["url"] = `/contact-directory/contact-industry-search.${bc["url"]}.html`
				}

				if (i === copiedBreadcrumbs.length - 1) {
					delete bc["url"]
				}

				return bc
			})

			crumbs = [...crumbs, ...result]
		}
		return crumbs
	}, [contactIndustryBreadcrumbData, contactIndustryHeaderDataInner?.addressLocality])

	if (isUndefinedOrNull(contactIndustryBreadcrumbData) || isUndefinedOrNull(contactIndustryHeaderDataInner)) {
		return <></>
	}

	let addressCountry = contactIndustryHeaderDataInner?.addressCountry?.replace(/_/g, " ");
	let addressLocality = contactIndustryHeaderDataInner?.addressLocality?.replace(/_/g, " ");
	let addressRegion = contactIndustryHeaderDataInner?.addressRegion?.replace(/_/g, " ");
	let industryTitle = contactIndustryHeaderDataInner?.industryTitle?.replace(/_/g, " ");

	const addressLocalityToUse =
		isNotUndefinedOrNull(addressLocality)
			? addressLocality.charAt(0).toUpperCase() + addressLocality.slice(1)
			: void 0;

	const addressRegionToUse =
		isNotUndefinedOrNull(addressRegion)
			? (addressRegion.charAt(0).toUpperCase() + addressRegion.slice(1))
			: void 0;

	addressCountry = isNotUndefinedOrNull(addressCountry) && addressCountry === "US" ?
		"United States Of America" : "";
	const addressDetailsArray = [addressLocalityToUse, addressRegionToUse, addressCountry];

	const addressDetailsArrayFiltered = filterOutUndefineds(addressDetailsArray);

	const addressDetails = addressDetailsArrayFiltered.join(", ");

	const contactDetails =
		isNotUndefinedOrNull(totalContacts) && totalContacts > 0
			? `View ${window.String(totalContacts)} ${window.String(industryTitle)} contact profiles below.`
			: "";

	return (
		<>
			<Helmet>
				<title>Find {industryTitle || ''} Contacts - Dun & Bradstreet</title>
			</Helmet>
			<div className="container">
				<div className="crawl-header-industry-container">
					{/* <ContactCrawlBreadcrumbFragmentComponent contactIndustryBreadcrumbData={contactIndustryBreadcrumbData} /> */}
					{breadcrumbs &&
						<Breadcrumb
							breadcrumbs={breadcrumbs}
							forComponent="contactIndustryPage"
							styling="text-tranform-none contact-industry-breadcrumb-item"
						/>
					}
					<h2 className="crawl-header-industry-title">
						{industryTitle}

						{" "}

						Contacts in

						{" "}

						{addressDetails}
					</h2>
				</div>
			</div>

			<div className="crawl-header-cd-bg-img">
				<div className="container">
					<div className="crawl-header-cd-container">
						<h3 className="crawl-header-cd-title">
							Contact Directory
						</h3>

						<p className="crawl-header-cd-desc">
							Find detailed information on contacts in the
							{" "}

							{industryTitle}

							{" "}

							industry in

							{" "}

							{addressDetails}

							, including contact information business profiles, and colleague information.

							{" "}

							{contactDetails}
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default ContactCrawlHeader;
